export const emojiAllowList = [
	'👍',
	'🎉',
	'❤️',
	'🚀',
	'🙏',
	'👏',
	'🔥',
	'🤔',
	'👀',
]
